import { render, staticRenderFns } from "./FreePaidChart.vue?vue&type=template&id=1ade6f45&scoped=true"
import script from "./FreePaidChart.vue?vue&type=script&lang=js"
export * from "./FreePaidChart.vue?vue&type=script&lang=js"
import style0 from "./FreePaidChart.vue?vue&type=style&index=0&id=1ade6f45&prod&lang=scss"
import style1 from "./FreePaidChart.vue?vue&type=style&index=1&id=1ade6f45&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ade6f45",
  null
  
)

export default component.exports